import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import '../sip/Calculators.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const House = () => {
    const [ownHouse, setOwnHouse] = useState(10);
    const [houseCost, setHouseCost] = useState(5000000);
    const [inflation, setInflation] = useState(6);
    const [expectedReturn, setExpectedReturn] = useState(12);
    const [results, setResults] = useState(null);
    const [pieData, setPieData] = useState(null);

    const calculateHouse = () => {
        // Future value = Present * (1 + inflation)^years
        const futureValue = houseCost * Math.pow(1 + inflation / 100, ownHouse);

        // SIP calculation
        const monthlyRate = expectedReturn / 100 / 12;
        const months = ownHouse * 12;
        const sipAmount = futureValue / (((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate));

        // Lumpsum calculation
        const lumpsumAmount = futureValue / Math.pow(1 + expectedReturn / 100, ownHouse);

        setResults({
            futureValue: Math.round(futureValue),
            sip: Math.round(sipAmount),
            lumpsum: Math.round(lumpsumAmount),
        });

        setPieData({
            labels: ['Planning Through SIP', 'Planning Through Lumpsum'],
            datasets: [
                {
                    data: [sipAmount, lumpsumAmount],
                    backgroundColor: ['#004aad', '#76d041'],
                    borderWidth: 1,
                },
            ],
        });
    };

    return (
        <div className="sip-calculator">
            <h2>House Planning</h2>

            <div className="input-group">
                <label>After how many years do you wish to own your dream home?</label>
                <input
                    type="range"
                    min="1"
                    max="60"
                    value={ownHouse}
                    onChange={(e) => setOwnHouse(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="1"
                    max="60"
                    value={ownHouse}
                    onChange={(e) => {
                        const val = e.target.value;
                        setOwnHouse(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Current Cost of your dream house</label>
                <input
                    type="range"
                    min="100000"
                    max="100000000"
                    step="10000"
                    value={houseCost}
                    onChange={(e) => setHouseCost(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="100000"
                    max="100000000"
                    step="10000"
                    value={houseCost}
                    onChange={(e) => {
                        const val = e.target.value;
                        setHouseCost(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Expected Inflation Rate (%)</label>
                <input
                    type="range"
                    min="0"
                    max="15"
                    step="0.1"
                    value={inflation}
                    onChange={(e) => setInflation(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="0"
                    max="15"
                    step="0.1"
                    value={inflation}
                    onChange={(e) => {
                        const val = e.target.value;
                        setInflation(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Expected Returns (%)</label>
                <input
                    type="range"
                    min="1"
                    max="20"
                    step="0.1"
                    value={expectedReturn}
                    onChange={(e) => setExpectedReturn(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="1"
                    max="20"
                    step="0.1"
                    value={expectedReturn}
                    onChange={(e) => {
                        const val = e.target.value;
                        setExpectedReturn(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <button onClick={calculateHouse} className="calculate-btn">Calculate</button>

            {results && (
                <div className="sip-output-section">
                    <div className="result-summary">
                        <h3>Results</h3>
                        <p>After {ownHouse} Years, My Dream House Cost Would Be: <span>₹{results.futureValue.toLocaleString()}</span></p>
                        <p>Planning Through SIP: <span>₹{results.sip.toLocaleString()}</span></p>
                        <p>Planning Through Lumpsum: <span>₹{results.lumpsum.toLocaleString()}</span></p>
                    </div>

                    {pieData && (
                        <div className="pie-chart-container">
                            <h3>SIP vs Lumpsum</h3>
                            <Pie data={pieData} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default House;
